import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { FormGroup } from '@angular/forms';

import { Tc } from 'src/app/components/core/_infrastructure/types/common';
import { PuntoInspeccionViewModel } from '../puntoinspeccion.types';

@Component({
    selector: 'app-puntoinspeccion-edit',
    templateUrl: './puntoinspeccion-edit.component.html',
})
export class PuntoInspeccionEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() puntoInspeccion: PuntoInspeccionViewModel;
    @Input() formGroup: FormGroup;
    @Input() listPais: Tc[];
    @Input() listProvincia: Tc[];
    @Input() listMunicipio: Tc[];
    @Input() listTipoPuntoInspeccion: Tc[];
    @Input() listZona: Tc[];
    @Input() submitted: boolean;

    @Output() selectProvincia = new EventEmitter<number>(); // Informa que ha cambiado la provincia
    @Output() selectPais = new EventEmitter<number>(); // Informa que ha cambiado el pais
    @Output() selectZona = new EventEmitter<number>(); // Informa que ha cambiado la zona
    @Output() selectMunicipio = new EventEmitter<number>(); // Informa que ha cambiado el municipio

    public isCollapsedDatosPif = false;
    public isCollapsedDatosReasignable = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        // Suscribirse al cambio del valor de 'ReasignableEx'
        this.form.get('ReasignableEx')?.valueChanges.subscribe(value => {
            this.toggleFields(value);
        });

        // Llamar a la función al iniciar para asegurarse de que los campos estén habilitados/deshabilitados correctamente
        this.toggleFields(this.form.get('ReasignableEx')?.value);

        this.updateForm();
    }

    toggleFields(value: boolean) {
        if (value) {
            // Si 'ReasignableEx' es true, habilitar 'FinesDeSemana'
            this.form.get('FinesDeSemana')?.enable();
        } else {
            // Si 'ReasignableEx' es false, deshabilitar 'FinesDeSemana'
            this.form.get('FinesDeSemana')?.disable();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.puntoInspeccion?.currentValue) {
            this.puntoInspeccion = { ...changes.puntoInspeccion.currentValue }; //@adua:clonado de objeto, un 'new', para refresco de cambios
            this.updateForm();
        }
        if (changes?.listPais?.currentValue) {
            this.formGroup.get('IdPais')?.enable();
        }
        if (changes?.listProvincia?.currentValue) {
            this.formGroup.get('IdProvincia')?.enable();
        }
        if (changes?.listMunicipio?.currentValue) {
            this.formGroup.get('IdMunicipio')?.enable();
        }
        if (changes?.listTipoPuntoInspeccion?.currentValue) {
            this.formGroup.get('IdTipoPuntoInspeccion')?.enable();
        }
        if (changes?.listZona?.currentValue) {
            this.formGroup.get('IdZona')?.enable();
        }
    }

    onSelectPais() {
        this.selectPais.emit(this.form.value.IdPais);
    }

    onSelectProvincia() {
        this.selectProvincia.emit(this.form.value.IdProvincia);
    }

    onSelectZona() {
        this.selectZona.emit(this.form.value.IdZona);
    }

    onSelectMunicipio() {
        this.selectMunicipio.emit(this.form.value.IdMunicipio);
    }

    /**
     * This functions sets the values in the puntoInspeccion (@Input) into the form.
     */

    private updateForm(): void {
        if (this.puntoInspeccion?.Id ?? 0 > 0) {
            this.formGroup.setValue({
                Id: this.puntoInspeccion.Id,
                IdPais: this.puntoInspeccion.IdPais,
                IdProvincia: this.puntoInspeccion.IdProvincia,
                Codigo: this.puntoInspeccion.Codigo,
                Descripcion: this.puntoInspeccion.Descripcion,
                IdTipoPuntoInspeccion: this.puntoInspeccion.IdTipoPuntoInspeccion,
                IdMunicipio: this.puntoInspeccion.IdMunicipio,
                HabilitadoParaImportacion: this.puntoInspeccion.HabilitadoParaImportacion,
                HabilitadoParaExportacion: this.puntoInspeccion.HabilitadoParaExportacion,
                HabilitadoSanidadExterior: this.puntoInspeccion.HabilitadoSanidadExterior,
                ReasignableEx: this.puntoInspeccion.ReasignableEx,
                FinesDeSemana: this.puntoInspeccion.FinesDeSemana,
                NumeroInspectores: this.puntoInspeccion.NumeroInspectores,
                IdZona: this.puntoInspeccion.IdZona,
                Email: this.puntoInspeccion.Email,
                Aduana: '',
                Ubicacion: '',
                HoraIntervalo: '',
                CodigoTraces: this.puntoInspeccion.CodigoTraces,
                Activo: this.puntoInspeccion.Activo,
                Localidad: this.puntoInspeccion.Localidad,
                CodigoPostal: this.puntoInspeccion.CodigoPostal,
                PorcentajeSemanal: this.puntoInspeccion.PorcentajeSemanal,
            });
        }

        this.form = this.formGroup; // componentBase uses this.form
    }

    isEspania() {
        return this.form.value.IdPais == this.getConfig().IdPaisEspania;
    }
}
